<template>
  <div class="form-materia-prima p-4 mt-4 bg-white border rounded shadow-sm">
    <h3 class="mb-4">Crear Materia Prima</h3>

    <form @submit.prevent="submitForm">

      <!-- Biomasa y Tipo -->
      <div class="seccion">
        <h6 class="mb-3">Origen y Tipo</h6>
        <div class="row">
          <div class="col-md-6">
            <label>Biomasa Origen</label>
            <label>Buscar Biomasa por Código</label>
            <input v-model="filtroBiomasa" class="form-control mb-2" placeholder="Código de biomasa..." />

            <select v-model.number="form.biomasa_id" class="form-select" @change="fetchCodigo" required>
              <option value="" disabled>Seleccione biomasa…</option>
              <option v-for="b in biomasaFiltrada" :key="b.id" :value="b.id">
                {{ b.tipo_biomasa }} ({{ b.peso }} {{ b.unidad_medida }}) - {{ formatDate(b.fecha_cosecha) }} - 
                {{ b.codigo }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label>Tipo de Materia Prima</label>
            <select v-model="form.tipo" class="form-select" required>
              <option value="" disabled>Seleccione tipo…</option>
              <option v-for="t in tiposMateria" :key="t.id" :value="t.id">{{ t.descripcion }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Código -->
      <div class="seccion">
        <h6 class="mb-3">Código de Materia Prima</h6>
        <div class="input-group">
          <input v-model="form.codigo" class="form-control bg-light" readonly required />
          <button class="btn btn-outline-primary" @click="fetchCodigo" type="button">Generar</button>
        </div>
      </div>

      <!-- Cantidad, Unidad, Humedad -->
      <div class="seccion">
        <h6 class="mb-3">Datos de Producción</h6>
        <div class="row">
          <div class="col-md-4">
            <label>Cantidad</label>
            <input v-model.number="form.cantidad" type="number" class="form-control" required />
          </div>
          <div class="col-md-4">
            <label>Unidad de Medida</label>
            <select v-model="form.unidad_medida" class="form-select" required>
              <option v-for="u in unidadesMedida" :key="u" :value="u">{{ u }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Humedad (%)</label>
            <input v-model.number="form.humedad_porcentaje" type="number" class="form-control" />
          </div>
        </div>
      </div>

      <!-- Fechas -->
      <div class="seccion">
        <h6 class="mb-3">Fechas Importantes</h6>
        <div class="row">
          <div class="col-md-6">
            <label>Fecha Fin Secado/Curado</label>
            <input v-model="form.fecha_fin_secado" type="date" class="form-control" required />
          </div>
          <div class="col-md-6">
            <label>Fecha de Vencimiento</label>
            <input v-model="form.fecha_vencimiento" type="date" class="form-control" @change="onVencimientoChange"
              required />
          </div>
          <div class="col-md-6 mt-3">
            <label>Días hasta vencimiento</label>
            <input v-model.number="diasVencimiento" type="number" class="form-control" @input="onDiasChange" min="0" />
          </div>
        </div>
      </div>

      <!-- Comentarios -->
      <div class="seccion">
        <h6 class="mb-3">Notas o Comentarios</h6>
        <textarea v-model="form.nota_calidad" class="form-control" rows="3"></textarea>
      </div>

      <!-- Botones -->
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" @click="$emit('cancelar')" class="btn btn-outline-secondary">Cancelar</button>
        <button type="submit" class="btn btn-success">Crear Materia Prima</button>
      </div>

    </form>
  </div>
</template>

<script>
import axios from '@/axios';
import { format, differenceInCalendarDays, addDays } from 'date-fns';
import { mapGetters } from 'vuex';

export default {
  name: 'FormMateriaPrimaCrear',
  data() {
    const hoy = new Date();
    return {
      filtroBiomasa: '',
      form: {
        biomasa_id: null,
        tipo: '',
        codigo: '',
        cantidad: null,
        unidad_medida: '',
        fecha_fin_secado: format(hoy, 'yyyy-MM-dd'),
        humedad_porcentaje: null,
        fecha_vencimiento: '',
        nota_calidad: ''
      },
      tiposMateria: [],
      unidadesMedida: [],
      listaBiomasa: [],
      diasVencimiento: null
    };
  },
  computed: {
    ...mapGetters(['getClubActual']),
    club_id() {
      return this.getClubActual.id;
    },
    biomasaFiltrada() {
      const filtro = this.filtroBiomasa.trim().toLowerCase();
      if (!filtro) return this.listaBiomasa;
      return this.listaBiomasa.filter(b =>
        b.codigo?.toLowerCase().includes(filtro)
      );
    }
  },
  async created() {
    await this.fetchTipos();
    await this.fetchUnidades();
    await this.fetchBiomasa();
  },
  methods: {
    formatDate(d) {
      return d ? format(new Date(d), 'dd/MM/yyyy') : '';
    },
    async fetchTipos() {
      const res = await axios.get('/api/constantes/tipos_de_materia_prima');
      this.tiposMateria = res.data;
    },
    async fetchUnidades() {
      const res = await axios.get('/api/constantes/unidades-medida');
      this.unidadesMedida = res.data;
    },
    async fetchBiomasa() {
      const res = await axios.get('/api/lista_biomasa_lista_produccion', { params: { club_id: this.club_id } });
      this.listaBiomasa = res.data;
    },
    async fetchCodigo() {
      if (!this.form.biomasa_id) return;
      const res = await axios.get('/api/materia_prima_generar_codigo', { params: { club_id: this.club_id, biomasa_id: this.form.biomasa_id } });
      this.form.codigo = res.data.codigo;
    },
    onVencimientoChange() {
      if (this.form.fecha_vencimiento) {
        this.diasVencimiento = differenceInCalendarDays(new Date(this.form.fecha_vencimiento), new Date());
      } else {
        this.diasVencimiento = null;
      }
    },
    onDiasChange() {
      if (this.diasVencimiento != null) {
        this.form.fecha_vencimiento = format(addDays(new Date(), this.diasVencimiento), 'yyyy-MM-dd');
      }
    },
    async submitForm() {
      const biomasa = this.listaBiomasa.find(b => b.id === this.form.biomasa_id);
      const payload = { ...this.form, club_id: this.club_id, lote_id: biomasa.lote_id, proyecto_id: biomasa.proyecto_id };

      await axios.post('/api/materia_prima', payload);
      alert('Materia Prima creada');
      this.$emit('materiaPrimaCreada', payload);
    }
  }
};
</script>

<style scoped>
.form-materia-prima {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.05);
}

.form-materia-prima h3 {
  font-weight: 600;
  color: #a84e1a;
}

.seccion {
  background-color: #f9f4f2;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #eee;
  margin-bottom: 24px;
}

label {
  font-weight: 500;
  color: #5c3a28;
}

input,
textarea,
select {
  font-size: 0.95rem;
}

.input-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-success {
  background-color: #a84e1a;
  border-color: #a84e1a;
}

.btn-success:hover {
  background-color: #843913;
  border-color: #843913;
}

.btn-outline-primary {
  border-color: #a84e1a;
  color: #a84e1a;
}

.btn-outline-primary:hover {
  background-color: #a84e1a;
  color: white;
}
</style>
